class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      const target = event.target;
      if (target.hasAttribute('data-with-warranty') && target.hasAttribute('data-is-hazardous')) {
        cartItems.onWithWarrantyAndHazardousChange(event);
      } else if (target.hasAttribute('data-is-hazardous')) {
        cartItems.onHazardousChange(event);
      } else if (target.hasAttribute('data-with-warranty')) {
        cartItems.onWithWarrantyChange(event);
      } else {
        cartItems.updateQuantity(this.dataset.index, 0);
      }
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));

    if (!this.querySelector('[data-cart-items-json]')) return;
    this.cartItemsData = this.querySelector('[data-cart-items-json]').textContent;
    if (!this.cartItemsData) return;
    this.cartItemsData = JSON.parse(this.cartItemsData);
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    const target = event.target;

    if (target.hasAttribute('data-warranty-field')) {
      this.onWarrantyChange(event);
    } else if (target.hasAttribute('data-with-warranty') && target.hasAttribute('data-is-hazardous')) {
      this.onWithWarrantyAndHazardousChange(event);
    } else if (target.hasAttribute('data-with-warranty')) {
      this.onWithWarrantyChange(event);
    } else if (target.hasAttribute('data-is-hazardous')) {
      this.onHazardousChange(event);
    } else {
      const activeElementName =
        document.activeElement.getAttribute('name') !== null
          ? document.activeElement.getAttribute('name')
          : target.name;
      this.updateQuantity(
        event.target.dataset.index,
        event.target.value,
        activeElementName,
        event.target.dataset.quantityVariantId
      );
    }
  }

  onWithWarrantyAndHazardousChange(event) {
    // first, we make sure we have the updated JSON
    this.cartItemsData = this.querySelector('[data-cart-items-json]').textContent;
    if (!this.cartItemsData) return;
    this.cartItemsData = JSON.parse(this.cartItemsData);

    // start
    const quantity = Number(event.target.value);
    const line = Number(event.target.dataset.index);
    const lipWarranty = event.target.dataset.withWarranty;
    const lipHazardous = event.target.dataset.isHazardous;
    const parentVariantId = event.target.dataset.quantityVariantId;
    const warrantyItem = this.cartItemsData.find((item) => {
      return item.properties['_warranty-key'] == lipWarranty && item.variant_id != parentVariantId;
    });
    const hazardousShipping = this.cartItemsData.find((item) => {
      return item.properties['_hazardous-key'] == lipHazardous && item.variant_id != parentVariantId;
    });
    const activeElementName =
      document.activeElement.getAttribute('name') !== null
        ? document.activeElement.getAttribute('name')
        : event.target.name;

    if (!warrantyItem && !hazardousShipping) return;
    const warrantyItemKey = warrantyItem.key;
    const hazardousShippingKey = hazardousShipping.key;
    const updatedData = new FormData();
    updatedData.append(`updates[${warrantyItemKey}]`, quantity);
    updatedData.append(`updates[${hazardousShippingKey}]`, quantity);

    fetch(`${routes.cart_update_url}.js`, {method: 'POST', body: updatedData})
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        const updatedLine = response.items.findIndex((item) => {
          return item.properties['_warranty-key'] == lipWarranty && item.id == parentVariantId;
        });
        this.updateQuantity(Number(updatedLine) + 1, quantity, activeElementName, parentVariantId);
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      });
  }

  onWarrantyChange(event) {
    // first, we make sure we have the updated JSON
    this.cartItemsData = this.querySelector('[data-cart-items-json]').textContent;
    if (!this.cartItemsData) return;
    this.cartItemsData = JSON.parse(this.cartItemsData);

    // start
    const target = event.target;
    const action = target.checked ? 'add' : 'remove';
    const warrantyKey = action == 'remove' ? target.dataset.warrantyKey : 'warranty-' + Date.now();
    const warrantyId = target.value;
    const warrantyItem = this.cartItemsData.find((item) => {
      return item.properties['_warranty-key'] == warrantyKey && item.id == warrantyId;
    });
    const parentItem = this.cartItemsData.find((item) => {
      return item.id == target.dataset.parentVariantId;
    });
    const activeElementName =
      document.activeElement.getAttribute('name') !== null ? document.activeElement.getAttribute('name') : target.name;
    const properties =
      action == 'remove'
        ? {'_warranty-key': '', '_warranty-price': ''}
        : {'_warranty-key': warrantyKey, '_warranty-price': target.dataset.price};

    // temporary disable the checkbox
    target.parentElement.classList.add('disabled');

    // remove warranty
    if (action == 'remove') {
      const body = JSON.stringify({
        id: warrantyItem.key,
        quantity: 0
      });

      fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{body}})
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          if (!response.items.length) return;

          const parentIndex = response.items.findIndex((item) => {
            return item.properties['_warranty-key'] == warrantyKey && item.id != warrantyId;
          });

          // find the new parent item after warranty remove
          const updatedParentItem = response.items.find((item) => {
            return item.id == target.dataset.parentVariantId;
          });

          let updatedProps = properties;

          if (updatedParentItem.properties && Object.keys(updatedParentItem.properties).length > 0) {
            updatedProps = {...updatedParentItem.properties, ...properties};
          }

          this.updateQuantity(
            Number(parentIndex) + 1,
            target.dataset.parentQuantity,
            activeElementName,
            target.dataset.parentVariantId,
            updatedParentItem.key,
            updatedProps
          );

          // temporary disable the checkbox
          target.parentElement.classList.remove('disabled');
        })
        .catch((e) => {
          console.error(e);
        });
    }
    // adding warranty
    else {
      // check if and use existing properties
      let parentProps = properties;
      let childProps = properties;

      if (parentItem.properties && parentItem.properties['_hazardous-key']) {
        childProps = {'_warranty-key': parentItem.properties['_hazardous-key'].replace('hazardous', 'warranty')};
        parentProps = {
          ...parentItem.properties,
          ...parentProps,
          ...childProps
        };
      }

      const line = target.closest('.cart-item').dataset.index;
      const body = JSON.stringify({
        items: [
          {
            id: warrantyId,
            quantity: target.dataset.parentQuantity,
            properties: {...childProps, For: target.dataset.parentName}
          }
        ]
      });

      fetch(`${routes.cart_add_url}`, {...fetchConfig(), ...{body}})
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          if (!parentItem.key) return;

          this.updateQuantity(
            line,
            target.dataset.parentQuantity,
            activeElementName,
            target.dataset.parentVariantId,
            parentItem.key,
            parentProps
          );

          // temporary disable the checkbox
          target.parentElement.classList.remove('disabled');
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  onWithWarrantyChange(event) {
    // first, we make sure we have the updated JSON
    this.cartItemsData = this.querySelector('[data-cart-items-json]').textContent;
    if (!this.cartItemsData) return;
    this.cartItemsData = JSON.parse(this.cartItemsData);

    // start
    const quantity = Number(event.target.value);
    const line = Number(event.target.dataset.index);
    const lip = event.target.dataset.withWarranty;
    const parentVariantId = event.target.dataset.quantityVariantId;
    const warrantyItem = this.cartItemsData.find((item) => {
      return item.properties['_warranty-key'] == lip && item.variant_id != parentVariantId;
    });
    const activeElementName =
      document.activeElement.getAttribute('name') !== null
        ? document.activeElement.getAttribute('name')
        : event.target.name;

    if (!warrantyItem) return;
    const warrantyItemKey = warrantyItem.key;
    const body = JSON.stringify({
      id: warrantyItemKey,
      quantity
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{body}})
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        const updatedLine = response.items.findIndex((item) => {
          return item.properties['_warranty-key'] == lip && item.id == parentVariantId;
        });
        this.updateQuantity(Number(updatedLine) + 1, quantity, activeElementName, parentVariantId);
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      });
  }

  onHazardousChange(event) {
    // first, we make sure we have the updated JSON
    this.cartItemsData = this.querySelector('[data-cart-items-json]').textContent;
    if (!this.cartItemsData) return;
    this.cartItemsData = JSON.parse(this.cartItemsData);

    // start
    const quantity = Number(event.target.value);
    const line = Number(event.target.dataset.index);
    const lip = event.target.dataset.isHazardous;
    const parentVariantId = event.target.dataset.quantityVariantId;
    const hazardousShipping = this.cartItemsData.find((item) => {
      return item.properties['_hazardous-key'] == lip && item.variant_id != parentVariantId;
    });
    const activeElementName =
      document.activeElement.getAttribute('name') !== null
        ? document.activeElement.getAttribute('name')
        : event.target.name;

    if (!hazardousShipping) return;
    const hazardousShippingKey = hazardousShipping.key;
    const body = JSON.stringify({
      id: hazardousShippingKey,
      quantity
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{body}})
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        const updatedLine = response.items.findIndex((item) => {
          return item.properties['_hazardous-key'] == lip && item.id == parentVariantId;
        });
        this.updateQuantity(Number(updatedLine) + 1, quantity, activeElementName, parentVariantId);
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      });
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
          this.reInitUpsell();
          this.classList.remove('temp-force-hide-errors');
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
          this.classList.remove('temp-force-hide-errors');
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents'
      }
    ];
  }

  updateQuantity(line, quantity, name, variantId, id = null, properties = null) {
    this.enableLoading(line);

    let parameters = {
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    };

    if (properties != null) parameters = {...parameters, properties};

    if (id != null) {
      parameters = {...parameters, id};
      delete parameters.line;
    }

    const body = JSON.stringify(parameters);

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{body}})
      .then((response) => {
        // Check if the response status indicates an error (4xx or 5xx)
        // Temporary solution to handle the bug when item is updated to its max quantity
        if (!response.ok) {
          const _this = this;
          response
            .text()
            .then((errorText) => {
              console.error('Error response body:', errorText);
              let tempErrorText = JSON.parse(errorText);
              if (tempErrorText.errors.includes('due to availability')) {
                _this.onCartUpdate();
              }
            })
            .catch((e) => console.error('Failed to read error response body:', e));

          // Throw an error or return a rejected promise to stop the downstream .then blocks
          // from trying to process a non-OK response as if it were successful state data.
          return Promise.reject('Redirecting due to API error');
        }

        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        const cartChange = new CustomEvent('cartChange', {
          detail: {
            cartTotal: parsedState.total_price
          }
        });
        document.dispatchEvent(cartChange);

        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items', cartData: parsedState, variantId: variantId});
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
        this.reInitUpsell();
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }

  reInitUpsell() {
    const sections = this.getSectionsToRender().map((section) => section.section);
    if (!sections.includes('cart-drawer')) return;
    const cartDrawer = document.getElementById('CartDrawer');
    if (!cartDrawer) return;
    const glide = cartDrawer.querySelector('glide-component');
    glide.setAttribute('data-wait-for-render', 'true');
    glide.initialize();
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({note: event.target.value});
            fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{body}});
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
